import React, { FC } from "react";
import { Form } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
// import { TextInput } from "../../atoms/TextInput";
// import { ButtonWithIcon } from "../../atoms/Button";
import {
  FormItem,
  ItemWrapper,
  // IconWrapper,
  // MinusCircleIcon,
  // ButtonWrapper,
  InputWrapper,
  InputTitle,
  Container,
  StyledSkillSelect,
} from "./elements";
import { validation } from "../../../constants";
import { skillsFormProps } from "./types";

const SkillsForm: FC<skillsFormProps> = (props) => {
  const { onFinish, formRef, yearsOfExperienceItems, skillList } = props;
  return (
    <Form
      onFinish={onFinish}
      form={formRef}
      initialValues={{ years_of_experience: "" }}
      style={{ paddingTop: "10px" }}
    >
      <Container>
        {skillList.map((value, index) => (
          <ItemWrapper key={skillList[index]}>
            <InputWrapper>
              <InputTitle>{value}</InputTitle>
              <FormItem
                name={[`${value}~${index}_experience`]}
                rules={[validation.requiredRuleWithCommonMessage]}
              >
                <StyledSkillSelect
                  getPopupContainer={(trigger) => {
                    return trigger;
                  }}
                  placeholder="Years of experience"
                >
                  {yearsOfExperienceItems}
                </StyledSkillSelect>
              </FormItem>
            </InputWrapper>
          </ItemWrapper>
        ))}
      </Container>
    </Form>
  );
};

export default SkillsForm;
